import { render, staticRenderFns } from "./Formreview.vue?vue&type=template&id=3c6f7301&scoped=true"
import script from "./Formreview.vue?vue&type=script&lang=js"
export * from "./Formreview.vue?vue&type=script&lang=js"
import style0 from "./Formreview.vue?vue&type=style&index=0&id=3c6f7301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f7301",
  null
  
)

export default component.exports